import { Component, Input } from '@angular/core';
import * as animations from '../../animations';

@Component({
  selector: 'tr-sidebar',
  animations: [animations.fadeInUpAnimation],
  templateUrl: './sidebar.component.html',
  //styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  @Input() stages: Object[];
  @Input() currentStageId: number;

}



// WEBPACK FOOTER //
// ./src/app/shared/components/sidebar/sidebar.component.ts